import React from 'react';
import './LoiSignersList.scss';
import {
    LoiSignerRole,
    LoiSignerStatus,
} from '../../slices/marketplace/loi-signing/models/loi-signing-status.model';
import { LoiSigningMode } from '../../slices/marketplace/loi-preparation/models/loi-co-owners-preview.model';

export interface LoiSignersListProps {
    signers: LoiSignerStatus[];
}

const roleLabels: Record<LoiSignerRole, string> = {
    [LoiSignerRole.PrimaryOwner]: 'Primary owner',
    [LoiSignerRole.FellowOwner]: 'Fellow Practice Owner',
    [LoiSignerRole.CoOwner]: 'Co-owner',
};

const modeLabels: Record<LoiSigningMode, string> = {
    [LoiSigningMode.InVetValue]: 'in VetValue',
    [LoiSigningMode.ByEmail]: 'by email',
};

export const LoiSignersList = (props: LoiSignersListProps) => {
    return (
        <ul className="loi-signers-list">
            {props.signers.map((signer, index) => (
                <li key={`${signer.name}-${signer.role}-${index}`} className="loi-signers-list__item">
                    <span className="loi-signers-list__name">{signer.name}</span>
                    <span className="text-muted small">
                        {roleLabels[signer.role]}, signs {modeLabels[signer.mode]}
                    </span>
                    <span
                        className={
                            signer.isSigned
                                ? 'loi-signers-list__status loi-signers-list__status--signed'
                                : 'loi-signers-list__status text-muted'
                        }>
                        {signer.isSigned ? 'Signed' : 'Waiting'}
                    </span>
                </li>
            ))}
        </ul>
    );
};

export default LoiSignersList;
